import "./Register.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
const API = process.env.REACT_APP_API_URL
export default function Register() {
    let navigate = useNavigate()

    const [nombre, setNombre] = useState("");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [direccion, setDireccion] = useState("");
    const [numeroCelular, setNumeroCelular] = useState("");

    const enviarDatos = async (e) => {
        e.preventDefault()

        let datos = {
            nombre,
            username,
            numeroCelular,
            email,
            password,
            direccion
        }


        let response = await fetch(API + "/user/registerCliente", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(datos)
        })

        let data = await response.json()

        setNombre("")
        setUsername("")
        setEmail("")
        setNumeroCelular("")
        setPassword("")

        alert("cuenta creada exitosamente inicia sesion con el usuario y password que ingresastes")

        console.log(data)

        setTimeout(() => {
            navigate("/login");
        }, 2000);

    }

    return (
        <div className="register-container">
            <div className="register-card">

                <h2 className="register-title">Crear cuenta</h2>
                <p className="register-subtitle">
                    Regístrate para acceder a la tienda
                </p>

                <form onSubmit={enviarDatos} className="register-form">

                    <input
                        type="text"
                        placeholder="Nombre completo"
                        className="register-input"
                        name="nombre"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        required
                    />

                    <input
                        type="text"
                        placeholder="Usuario"
                        className="register-input"
                        name="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />

                    <label htmlFor="email">Ingrese su correo electrónico gmail para recibir la información de su pedido.</label>

                    <input
                        type="email"
                        placeholder="Correo electrónico"
                        className="register-input"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />


                    <input
                        type="numeroCelular"
                        placeholder="numero celular"
                        className="register-input"
                        name="text"
                        value={numeroCelular}
                        onChange={(e) => setNumeroCelular(e.target.value)}
                        required
                    />

                    <input
                        type="password"
                        placeholder="Contraseña"
                        className="register-input"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <input
                        type="text"
                        placeholder="direccion"
                        className="register-input"
                        name="direccion"
                        value={direccion}
                        onChange={(e) => setDireccion(e.target.value)}
                        required
                    />

                    <button type="submit" className="register-btn">
                        Crear cuenta
                    </button>

                </form>

                <div className="register-footer">
                    <span>¿Ya tienes cuenta?</span>
                    <a href="/login">Iniciar sesión</a>
                </div>

            </div>
        </div>
    );
}
